Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = void 0;

var core_1 = require("@emotion/core");

var core_2 = require("@wheelroom/core");

exports.List = function (props) {
  if (!props.blogPosts) {
    return null;
  }

  return core_1.jsx(core_2.Ul, {
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style
    })
  }, props.blogPosts && props.blogPosts.map(function (blog, index) {
    var _a;

    if (!blog) {
      return null;
    }

    var dateEvent = new Date(Date.parse(blog.date));
    var dateOptions = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };
    var dateTime = dateEvent.toLocaleDateString(props.locale, dateOptions);
    var categories = blog.categories;

    if (!categories) {
      categories = [];
    }

    var getCategories = categories.length > 0 ? categories.join(', ') : '';
    return core_1.jsx(core_2.Li, {
      key: index,
      wheel: Object.assign(Object.assign({}, props.wheel), {
        style: props.wheel.style.item
      })
    }, core_1.jsx(core_2.GLink, {
      wheel: Object.assign(Object.assign({}, props.wheel), {
        style: props.wheel.style.link
      }),
      to: '/blog/' + blog.slug,
      ariaLabel: blog.heading + ' - ' + categories + ' - ' + dateTime
    }, !props.data.hideMedia && core_1.jsx(core_2.Flex, {
      is: "div",
      wheel: Object.assign(Object.assign({}, props.wheel), {
        style: props.wheel.style.media
      })
    }, core_1.jsx(core_2.Image, {
      media: blog.media,
      wheel: Object.assign(Object.assign({}, props.wheel), {
        style: props.wheel.style.image
      })
    })), !props.data.hideContent && core_1.jsx(core_2.Flex, {
      is: "div",
      wheel: Object.assign(Object.assign({}, props.wheel), {
        style: props.wheel.style.content
      })
    }, !props.data.hideCategories && core_1.jsx(core_2.Any, {
      wheel: Object.assign(Object.assign({}, props.wheel), {
        style: props.wheel.style.categories
      }),
      is: "span"
    }, getCategories), !props.data.hideText && core_1.jsx(core_2.Box, {
      is: "div",
      wheel: Object.assign(Object.assign({}, props.wheel), {
        style: props.wheel.style.text
      })
    }, !props.data.hideHeading && core_1.jsx(core_2.Heading, {
      is: "h3",
      wheel: Object.assign(Object.assign({}, props.wheel), {
        style: props.wheel.style.heading
      })
    }, blog.heading), !props.data.hideAbstract && core_1.jsx(core_2.Paragraph, {
      wheel: Object.assign(Object.assign({}, props.wheel), {
        style: props.wheel.style.abstract
      })
    }, (_a = blog.abstract) === null || _a === void 0 ? void 0 : _a.abstract)), !props.data.hideDate && core_1.jsx(core_2.Time, {
      wheel: Object.assign(Object.assign({}, props.wheel), {
        style: props.wheel.style.date
      }),
      datetime: blog.date
    }, dateTime))));
  }));
};